import unityTranslations from './unity.js';
﻿// ============================================================================
// ITALIAN TRANSLATIONS - UI
// ============================================================================

export const uiTranslations = {
  meta: {
    language: 'it',
    languageName: 'Italiano',
    version: '1.0'
  },
  
  app: {
    title: "UNITYQUEST Cronache\ndell'Amore",
    subtitle: "Scoperta Interattiva delle Scritture",
    tagline: "Camminare verso la luce divina",
    menu: "Menu",
    retry: "Riprova"
  },
  
  buttons: {
    play: "GIOCA",
    back: "Indietro",
    continue: "Continua",
    restart: "Ricomincia",
    close: "Chiudi",
    nextLevel: "Livello Successivo",
    selectLevel: "Selezione Livelli",
    retry: "Riprova",
    mainMenu: "Menu Principale",
    start: "Inizia",
    cancel: "Annulla",
    confirm: "Conferma",
    save: "Salva",
    load: "Carica",
    yesRestart: "Sì, ricomincia",
    noContinue: "No, continua",
    tryAgain: "Riprova",
    backToMenu: "Torna al menu"
  },
  
  labels: {
    score: "Punteggio",
    stars: "Stelle",
    wisdom: "Saggezza",
    revelation: "Rivelazione",
    lives: "Vite",
    combo: "Combo",
    level: "LIVELLO",
    easy: "FACILE",
    medium: "MEDIO",
    hard: "DIFFICILE",
    correct: "Corretto!",
    gameOver: "Prova Fallita",
    victory: "Vittoria!",
    completed: "Completato",
    rank: "Rango Spirituale",
    points: "Punti Saggezza",
    unlockedLevels: "livello(i) sbloccato(i)",
    questionOfKnowledge: "Domanda di Conoscenza",
    hintOfWisdom: "Suggerimento di Saggezza",
    knowledgeMastered: "Conoscenza Acquisita!",
    knowledgeAcquired: "Conoscenza Ottenuta!",
    testFailed: "Prova Fallita",
    wisdomBonus: "Bonus",
    xpGained: "XP",
    newRank: "Nuovo rango",
    nextGrade: "Prossimo grado",
    maxLevelReached: "Livello massimo raggiunto!",
    wrongAnswer: "Risposta sbagliata!"
  },
  
  menu: {
    playButton: "GIOCA",
    info: "Info",
    treasures: "Tesori",
    john: "Giovanni",
    reset: "Resetta",
    resetConfirm: "Ricominciare l'avventura?",
    resetWarning: "Sei sicuro di voler cancellare tutti i tuoi progressi?",
    resetLose: "Perderai:",
    wisdomPoints: "Punti Saggezza",
    starsCollected: "stelle raccolte",
    levelsUnlocked: "livelli sbloccati",
    spiritualRank: "Rango Spirituale",
    yesRestart: "S├¼, ricomincia",
    noContinue: "No, continua",
    newAdventure: "Nuova Avventura",
    readyToStart: "Pronto a iniziare?",
    startJourney: "Inizia il tuo viaggio nella conoscenza delle Scritture!",
    audioControls: "Controlli audio",
    mute: "Disattiva audio",
    unmute: "Attiva audio",
    close: "Chiudi",
    language: "Lingua",
    restartGame: "Riavvia il gioco"
  },
  
  login: {
    title: "UNITY QUEST",
    subtitle: "Avventura biblica interattiva",
    anonymousMode: "Gioca Anonimo",
    anonymousDesc: "Scegli un nickname",
    emailMode: "Accesso Email",
    emailDesc: "Salvataggio multi-dispositivo",
    pseudo: "Nickname",
    pseudoPlaceholder: "Il tuo nickname...",
    email: "Indirizzo Email",
    emailPlaceholder: "tua@email.com",
    startPlaying: "Inizia a giocare",
    sendLink: "Invia link",
    sending: "Invio...",
    connecting: "Connessione...",
    back: "Indietro",
    localSave: "I tuoi progressi saranno salvati localmente",
    cloudSync: "Nessuna password richiesta • Sincronizzazione cloud",
    magicLink: "Ricevi un link magico via email",
    checkEmail: "📧 Controlla la tua email! Un link di accesso ï stato inviato.",
    checkSpam: "Controlla anche la cartella spam",
    waitingConnection: "In attesa di connessione...",
    errorSend: "Errore nell'invio del link",
    rateLimited: "⏳ Attendere 15 secondi prima di inviare nuovamente un'email",
    importSession: "🔄 Importa sessione da produzione",
    errorConnection: "Errore di connessione",
    enterPseudo: "Inserisci un nickname",
    enterEmail: "Inserisci un'email valida",
    // Tooltips
    never: "Mai",
    save: "Salva partita",
    lastSave: "ultima",
    refresh: "Ricarica progressi",
    logout: "Disconnetti",
    connectToCloud: "Connetti per salvare online",
    editPseudo: "Modifica utente",
    confirm: "Conferma",
    cancel: "Annulla",
    close: "Chiudi",
    passwordMode: "Accesso Semplice",
    passwordDesc: "Email + password",
    password: "Password",
    passwordPlaceholder: "Minimo 6 caratteri",
    passwordMinLength: "Minimo 6 caratteri",
    playWithoutAccount: "Gioca senza account",
    forgotPassword: "Hai dimenticato la password?",
    resetPasswordTitle: "Reimposta Password",
    resetPasswordSubtitle: "Inserisci la tua email per ricevere un link di reimpostazione",
    sendResetLink: "Invia Link",
    resetEmailSent: "📧 Email di reimpostazione inviata! Controlla la tua casella di posta.",
    errorReset: "Errore nell'invio dell'email",
    backToSignin: "Torna al Login",
    newPassword: "Nuova Password",
    enterNewPassword: "Scegli una nuova password sicura",
    confirmPassword: "Conferma Password",
    updatePassword: "Aggiorna Password",
    passwordsDontMatch: "Le password non corrispondono",
    passwordUpdateSuccess: "✅ Password aggiornata con successo!",
    errorUpdatePassword: "Errore nell'aggiornamento della password",
    resetLinkExpired: "Link di reimpostazione scaduto o non valido",
    forgotPassword: "Hai dimenticato la password?",
    signup: "Registrati",
    signin: "Accedi",
    createAccount: "Crea Account",
    signupInfo: "Compila il modulo qui sotto",
    passwordInfo: "Accesso rapido con password",
    signupButton: "Crea Il Mio Account",
    signinButton: "Accedi",
    passwordTooShort: "La password deve contenere almeno 6 caratteri",
    emailAlreadyExists: "Questa email è già in uso",
    emailExistsHint: "✉️ Questa email è già registrata. Prova ad accedere! (Forse creata da un altro gioco?)",
    switchToSignin: "🔑 Passa alla modalità Accedi con la tua email esistente",
    invalidCredentials: "Email o password non validi",
    signupSuccess: "📧 Account creato! Controlla la tua email per confermare la registrazione.",
    emailConfirmationRequired: "Controlla la tua casella di posta per attivare il tuo account",
    checkSpamFolder: "Ricorda di controllare la cartella spam/posta indesiderata",
    connectionSuccess: "✅ Accesso riuscito!",
    errorSignup: "Errore durante la registrazione"},
  
  install: {
    title: "Installa l'app",
    subtitle: "Accesso rapido e offline",
    feature1: "Avvio istantaneo dalla schermata iniziale",
    feature2: "Funziona offline dopo l'installazione",
    feature3: "Esperienza app nativa",
    feature4: "Nessun download da store richiesto",
    install: "Installa",
    dismiss: "Dopo",
    info: "Puoi disinstallare l'app in qualsiasi momento"
  },
  
  ranks: {
    seeker: "Cercatore",
    believer: "Il Risvegliato",
    disciple: "Discepolo",
    servant: "Servitore",
    witness: "Testimone",
    guardian: "Guardiano",
    wise: "Saggio",
    prophet: "Profeta",
    apostle: "Apostolo",
    seekerDesc: "Inizio del viaggio spirituale",
    believerDesc: "Coscienza spirituale risvegliata",
    discipleDesc: "Apprendimento degli insegnamenti",
    servantDesc: "Servizio e devozione",
    witnessDesc: "Condivisione della fede",
    guardianDesc: "Protezione della verità",
    wiseDesc: "Saggezza e conoscenza",
    prophetDesc: "Visione spirituale",
    apostleDesc: "Maestro spirituale"
  },

  spiritualJourney: {
    beginning: "Inizio del viaggio spirituale",
    progress: "Progresso spirituale",
    grade: "Grado",
    xp: "XP",
    level: "Livello",
    nextGrade: "Prossimo grado",
    still: "Ancora",
    maxLevelReached: "Livello Massimo Raggiunto!",
    masteredAllTeachings: "Hai padroneggiato tutti gli insegnamenti",
    progression: "Progressione"
  },
  
  treasures: {
    title: "📖 Tesori della Bibbia",
    verse: "Versetto del giorno",
    fact: "Lo sapevi?",
    treasure: "Tesoro nascosto",
    question: "Domanda curiosa",
    context: "Contesto",
    strongReference: "Riferimento biblico per studio approfondito",
    verseOfDay: "🃏 Versetto del giorno",
    didYouKnow: "🤔 Lo sapevi?",
    hiddenTreasure: "💎 Tesoro nascosto",
    funnyQuestion: "😄 Domanda curiosa",
    emmanuelMemo: "Nota di Emmanuel",
    emmanuelMessage: "Sei arrivato in cima alla montagna, e la conoscenza ï acquisita. Ma la fede incrollabile richiede esperienza di vita, misericordia e vero amore di Ges├╣. Le varie prove della vita metteranno alla prova il tuo cammino, il vero percorso che scegliamo, il nostro cuore. Rimaniamo imperfetti, i nostri desideri sono numerosi, e l'amore per il guadagno o per il nostro comfort personale diventa troppo spesso la nostra priorità egoistica. Chiedi a Dio saggezza, il suo amore, la sua forza, e riconosci umilmente le tue debolezze, perché nulla pu├▓ essere nascosto a Lui... Nulla. Non c'ï bisogno di navigare in modalità privata, usare VPN, o persino cancellare la cronologia. Digiuna come Daniele: privati per un momento di ci├▓ che ami di pi├╣, nella calma e nella saggezza. Questo ti permetterà di ascoltare meglio Dio, di avere una disposizione del cuore pronta per trasformazioni profonde - e spesso dolorose. Allora i sogni e le visioni diventeranno pi├╣ chiari, come per Giuseppe. Ma guardati dall'orgoglio: non cedere a 'Ho sempre ragione' o 'Lo so meglio'. Perché la rivelazione di Dio ï una grazia straordinaria. Non diventare un dottore della Legge, capace di crocifiggere Ges├╣ di nuovo oggi, Lui che chiede semplicemente di amare il tuo prossimo... e concedere loro la stessa libertà che ricevi. Avere fede significa entrare in una relazione libera e un viaggio del cuore. Ti renderà eroi potenti, capaci dell'impossibile. Perché l'esperienza del soprannaturale, la presenza di Dio, la sua conferma o benedizione ti renderà veramente incrollabile.",
    jesusIsNot: "❌ Chiarimento importante",
    clarification: "Chiarimento importante",
    bibleOffline: "Leggi Bibbia Offline",
    bibleStudy: "Studio biblico",
    version: "Versione",
    openReader: "Apri lettore",
    features: "Funzionalità"
  },
  
  messages: {
    chooseCard: "🃏 Scegli la tua carta potere",
    cardHelp: "Ti accompagnerà per le 3 domande di questo livello",
    chooseAnswer: "📖 Scegli la tua risposta:",
    wrongAnswer: "❌ Risposta sbagliata! Ti restano {lives} vita(e). Riprova!",
    levelCompleted: "Livello {level} Completato",
    questionsProgress: "Domanda {current} di 3",
    starsCollected: "Stelle raccolte: {current}/{total}",
    pointsEarned: "+{points} Punti Saggezza",
    defeatedQuote: "Tutto posso in colui che mi fortifica",
    secretChapter: "🎁 Capitolo Segreto",
    returnToLevels: "Indietro",
    next: "Avanti",
    retry: "Riprova",
    menu: "Menu",
    chapter: "Capitolo",
    chapterStars: "stelle del capitolo",
    totalGlobal: "Totale globale",
    backToMenu: "Torna al Menu"
  },
  
  quotes: {
    wisdom: "Il timore del Signore ï l'inizio della saggezza",
    faith: "Tutto posso in colui che mi fortifica",
    hope: "Il Signore ï il mio pastore, nulla mi mancherà",
    love: "Poiché Dio ha tanto amato il mondo...",
    perseverance: "La fede richiede perseveranza",
    defeat: "Il fallimento invita a crescere nella conoscenza"
  },

  cards: {
    faith: "FEDE",
    courage: "CORAGGIO",
    wisdom: "SAGGEZZA",
    faithKnowledge: "+50% punti",
    courageKnowledge: "Seconda possibilità",
    wisdomKnowledge: "Suggerimento + bonus",
    faithDesc: "Massimo di punti saggezza ottenuti",
    courageDesc: "Punti normali ma seconda possibilità",
    wisdomDesc: "Suggerimento rivelato e +25% punti",
    chooseCard: "🃏 Scegli un dono di conoscenza",
    cardEffects: "🃏 Effetti dei doni di conoscenza:",
    faithEffect: "+50% punti saggezza - Ricompensa massima",
    courageEffect: "Punti normali ma seconda possibilità in caso di errore",
    wisdomEffect: "+25% punti + suggerimento rivelato per ogni domanda",
    chooseWisely: "Scegli con saggezza, perché la tua scelta ti accompagnerà per tutto il livello"
  },

  challenge: {
    loading: "Caricamento del livello...",
    peace: "🕊️ Che la pace riposi nella tua casa",
    questionsAwaiting: "🎯 3 domande di conoscenza ti aspettano",
    starsQuote: "Ogni stella è un passo verso la luce divina"
  },

  chapters: {
    "1": "Genesi",
    "2": "Esodo",
    "3": "Ges├╣ Cristo",
    "4": "Crocifissione/Risurrezione",
    "5": "Chiesa primitiva",
    "6": "Missioni di Paolo",
    "7": "Lettere/Apocalisse",
    "8": "Livello bonus"
  },

  bible: {
    readerTitle: "📖 Lettore della Bibbia",
    loading: "Caricamento delle Scritture...",
    menu: "Menu",
    tabBible: "Bibbia",
    tabUnity: "Unità",
    strong: "Strong",
    strongReferences: "Riferimenti Strong",
    verses: "versetti",
    previous: "Precedente",
    next: "Successivo",
    strongDefinition: "Riferimento Strong",
    word: "Parola originale",
    transliteration: "Traslitterazione",
    pronunciation: "Pronuncia",
    meaning: "Significato",
    definition: "Definizione completa",
    usage: "Uso biblico",
    etymology: "Etimologia",
    close: "Chiudi",
    moreReferences: "e {{count}} altri riferimenti",
    copyright: "📖 Dominio pubblico • Strong"
  },

  bibleResources: {
    inAppReader: {
      name: "Leggi nell'App",
      description: "Lettore Bibbia integrato con Strong",
      features: {
        offline: "Offline",
        strong: "Numeri Strong",
        navigation: "Navigazione"
      }
    }
  },

  philosophy: {
    title: "Dimensione filosofica",
    loveOntology: "L'amore come principio ontologico",
    loveDescription: "Ges├╣ trasforma l'amore in fondamento metafisico: amare Dio e il prossimo diventa la struttura stessa dell'essere autentico. L'amore trascende la morale per diventare modo di esistenza.",
    newCommandment: "Il Nuovo Comandamento",
    jesusEmphasizes: "Quando Ges├╣ dà un nuovo comandamento, enfatizza il verbo amare",
    loveGod: "Ama Dio con tutto il tuo cuore",
    loveNeighbor: "Ama il tuo prossimo come te stesso",
    lovePriority: "L'amore diventa una priorità"
  },

  footer: {
    version: "Versione 1.0 • 2024",
    dedication: "Sviluppato per la gloria di Dio"
  },

  endCredits: {
    lines: [
      { text: "Sei arrivato in cima alla montagna", delay: 2000 },
      { text: "Hai imparato molte cose", delay: 2000 },
      { text: "La tua fede cresce ogni giorno", delay: 2000 },
      { text: "Vivi cose belle con Dio", delay: 2000 },
      { text: "Le difficoltà ti aiutano a crescere", delay: 2000 },
      { text: "Mostrano ci├▓ che ï importante", delay: 2000 },
      { text: "Sii umile come un bambino piccolo", delay: 2000 },
      { text: "Dio ama il tuo cuore semplice", delay: 2000 },
      { text: "Nella calma ascolti Dio", delay: 2000 },
      { text: "Il digiuno libera il tuo spirito", delay: 2000 },
      { text: "Prega e Dio ti guiderà", delay: 2000 },
      { text: "L'orgoglio nasconde la verità", delay: 2000 },
      { text: "La grazia di Dio ï magnifica", delay: 2000 },
      { text: "Viene dal cuore di Dio", delay: 2000 },
      { text: "La vera fede ti rende libero", delay: 2000 },
      { text: "Ti unisce a Dio per sempre", delay: 2000 },
      { text: "L'amore pu├▓ cambiare tutto", delay: 2000 },
      { text: "Pu├▓ fare miracoli", delay: 2000 },
      { text: "Ripeti con me", delay: 2000 },
      { text: "Ges├╣, ti do il mio cuore", delay: 3000 },
      { text: "Sei il mio re, il mio salvatore", delay: 3000 },
      { text: "Vieni a trasformare la mia vita", delay: 3000 },
      { text: "Il cammino continua ora", delay: 2000 },
      { text: "Condividi questa bella luce", delay: 2000 },
      { text: "Verso la vita che non finisce mai", delay: 2000 },
      { text: "Custodisci l'amore nel tuo cuore", delay: 3000 },
      { text: "Come un tesoro prezioso", delay: 3000 }
    ],
    finalMessages: {
      congratulations: "CONGRATULAZIONI!",
      proud: "SIAMO ORGOGLIOSI DI TE",
      courage: "GUERRIERO CORAGGIOSO",
      peace: "PORTATORE DI PACE",
      child: "FIGLIO DI DIO",
      blessing: "DIO TI BENEDICA",
      continue: "Continua"
    }
  },

  mountain: {
    spiritualAscension: "Ascensione Spirituale",
    levelProgress: "Livello {{level}} • {{stars}} stelle ottenute",
    combo: "Combo",
    perfectMessage: "\"Perché i miei pensieri non sono i vostri pensieri\" - L'agnello sale verso la saggezza perfetta",
    goodMessage: "\"Cercate e troverete\" - L'ascesa continua verso la verità",
    startMessage: "\"La fede, anche piccola come un granello di senape\" - Primo passo verso la luce",
    skipAnimation: "Salta animazione",
    chapter: "Capitolo",
    chapterProgress: "Capitolo {{current}}/{{total}}",
    secret: "Segreto",
    waypoints: {
      start: "Inizio",
      firstSlope: "Prima pendenza",
      lastSlope: "Ultima pendenza"
    },
    status: {
      defeat: "Sconfitta",
      inProgress: "In corso",
      victory: "Vittoria"
    }
  },

  validation: {
    pseudoTooShort: "Il nome utente deve contenere almeno 2 caratteri",
    enterPseudo: "Inserisci un nome utente"
  },

  pseudoSetup: {
    title: "Scegli il tuo nome utente",
    confirm: "Conferma Nome"
  },

  navigation: {
    back: "Indietro"
  },

  console: {
    starsUnlocked: "stelle raggiunte! Sblocco capitolo",
    defeatAnimation: "Sconfitta... G.C. ridiscende"
  },

  errors: {
    progressionError: "Errore di progressione",
    invalidProgressionData: "Dati di progressione non validi:"
  },

  levels: {
    chaptersAndBonus: "8 capitoli + livello bonus",
    bonusUnlocked: "🎁 LIVELLO BONUS SBLOCCATO! Hai raggiunto la perfezione spirituale!",
    starsToDiscover: "273 {stars} da scoprire",
    starsPerLevel: "3 {stars} per livello"
  },

  architecture: {
    title: "⚙️ Architettura tecnica",
    react: {
      name: "React",
      description: "Interfaccia moderna"
    },
    modules: {
      name: "Moduli",
      description: "Caricamento dinamico"
    },
    localStorage: {
      name: "LocalStorage",
      description: "Archiviazione locale"
    },
    tailwind: {
      name: "Tailwind",
      description: "Design responsive"
    }
  },

  gameManager: {
    title: "Salvataggio gioco",
    saveLocal: "Salvataggio locale",
    saveCloud: "Cloud sincronizzato",
    saveWaiting: "In attesa di connessione",
    lastSave: "Ultimo salvataggio:",
    never: "Mai",
    saving: "Salvataggio...",
    save: "Salva",
    loadProgress: "Carica",
    loading: "Caricamento...",
    autoSaveEnabled: "💾 Salvataggio automatico attivato",
    saveError: "❌ Errore di salvataggio",
    gameSaved: "✅ Gioco salvato!",
    gameLoaded: "✅ Gioco caricato!"
  },

  info: {
    title: "Unity Quest Cronache di Pace",
    subtitle: "Scoperta interattiva delle Scritture",
    yourStats: "Le Tue Statistiche",
    score: "Punteggio",
    wisdom: "Saggezza",
    revelation: "Rivelazione",
    createdWith: "Creato con ❤️",
    creator: "Emmanuel Payet",
    developerPassionate: "Sviluppatore appassionato di spiritualità",
    artistModule: "Emmanuel Artista",
    artistPortfolio: "Portfolio artistico e creazioni digitali",
    features: "Caratteristiche",
    multipleChapters: "91 livelli distribuiti in 8 capitoli biblici",
    powerCards: "3 carte potere uniche (Fede, Coraggio, Saggezza)",
    progressionSystem: "Sistema di progressione con ranghi spirituali",
    bibleTreasures: "Tesori biblici e fatti interessanti",
    howToPlay: "Come Giocare",
    selectLevel: "Seleziona un livello sbloccato",
    choosePowerCard: "Scegli la tua carta potere",
    answerQuestions: "Rispondi alle 3 domande di conoscenza",
    earnStars: "Guadagna stelle in base alle vite rimaste",
    tips: "Suggerimenti",
    readCarefully: "Leggi attentamente ogni domanda",
    useWisdomCard: "Usa la carta Saggezza per gli indizi",
    courageGivesSecondChance: "La carta Coraggio ti dà una seconda possibilità",
    faithMaximizes: "La carta Fede massimizza i tuoi punti",
    johnGospelTitle: "Vangelo di Giovanni",
    johnGospelStats: "21 capitoli • 878 versetti • 14 lingue",
    bibleReaderStrong: "Lettore Bibbia + Strong",
    bibleReaderStrongDesc: "Lettura completa con dizionario Strong",
    johnTreasures: "Tesori di Giovanni",
    johnTreasuresDesc: "Tesori biblici e fatti interessanti",
    quickAccessChapters: "Accesso rapido ai capitoli famosi:",
    johnChapter1: "Prologo",
    johnChapter3: "Rinascere",
    johnChapter14: "Io sono la via",
    johnChapter20: "Risurrezione",
    version: "Versione",
    madeWithLove: "Fatto con amore per la gloria di Dio",
    backToMenu: "Torna al Menu"
  },

  bible: {
    readerTitle: "📖 Lettore Bibbia",
    johnReaderTitle: "Lettore Bibbia - Vangelo di Giovanni",
    john: "Giovanni",
    loading: "Caricamento delle Scritture...",
    loadingChapter: "Capitolo {chapter} del Vangelo di Giovanni. I dati completi stanno caricando...",
    exploreWhileLoading: "Nel frattempo, puoi esplorare altri capitoli o utilizzare la funzione di ricerca.",
    menu: "Menu",
    tabBible: "Bibbia",
    tabUnity: "Unità",
    strong: "Strong",
    strongReferences: "Riferimenti Strong",
    verses: "versetti",
    previous: "Precedente",
    next: "Successivo",
    strongDefinition: "Riferimento Strong",
    word: "Parola originale",
    transliteration: "Traslitterazione",
    close: "Chiudi",
    share: "Condividi",
    shareVerse: "Condividi questo versetto",
    shareSelection: "Condividi la selezione",
    pronunciation: "Pronuncia",
    meaning: "Significato",
    definition: "Definizione completa",
    usage: "Uso biblico",
    etymology: "Etimologia",
    search: "Cerca...",
    definitionNotFound: "Definizione non trovata",
    definitionLoading: "Definizione da caricare...",
    imageFeatureComing: "🖼️ Funzionalità immagine in arrivo!",
    copyError: "Errore durante la copia:",
    error: "❌ Errore",
    errorLoading: "Errore di caricamento",
    retry: "Riprova",
    readerInDevelopment: "Lettore Bibbia Giovanni in sviluppo...",
    verseCopied: "Versetto copiato negli appunti!",
    moreReferences: "e {{count}} altri riferimenti",
    copyright: "📖 LSG 1910 • Strong inclusi",
    markAsRead: "Brano letto",
    alreadyRead: "Già letto",
    readingBonus: "Bonus di lettura",
    results: "risultati",
    result: "risultato",
    copy: "Copia",
    image: "Immagine"
  },

  mountain: {
    chapter: "Capitolo",
    secret: "Segreto!",
    spiritualAscension: "Ascensione Spirituale",
    levelProgress: "Livello {{level}} • {{stars}} stelle ottenute",
    combo: "Combo",
    perfectMessage: '"Perché i miei pensieri non sono i vostri pensieri" - L\'agnello sale verso la saggezza perfetta',
    goodMessage: '"Cercate e troverete" - La salita continua verso la verità',
    startMessage: '"La fede, anche piccola come un granello di senape" - Primo passo verso la luce',
    skipAnimation: "Salta animazione",
    stats: {
      points: "pt",
      level: "Liv."
    },
    waypoints: {
      start: "Partenza",
      firstSlope: "Prima pendenza",
      lastSlope: "Ultima pendenza"
    },
    status: {
      victory: "Vittoria!",
      defeat: "Sconfitta",
      inProgress: "In corso"
    }
  },

  bibleResources: {
    inAppReader: {
      name: "Leggi nell'App",
      description: "Lettore Bibbia integrato con Strong",
      features: {
        offline: "Offline",
        strong: "Numeri Strong",
        navigation: "Navigazione"
      }
    }
  },

  quotes: {
    wisdom: "La vera conoscenza porta alla saggezza eterna",
    faith: "Tutto posso in colui che mi fortifica",
    hope: "Il Signore è il mio pastore, non manco di nulla",
    love: "Perché Dio ha tanto amato il mondo...",
    perseverance: "La fede richiede perseveranza",
    defeat: "Il fallimento invita a crescere nella conoscenza"
  },

  philosophy: {
    title: "Dimensione filosofica",
    loveOntology: "L'amore come principio ontologico",
    loveDescription: "Gesù trasforma l'amore in fondamento metafisico: amare Dio e il prossimo diventa la struttura stessa dell'essere autentico. L'amore trascende la morale per diventare modo di esistenza.",
    newCommandment: "Il Nuovo Comandamento",
    jesusEmphasizes: "Quando Gesù dà un nuovo comandamento, accentua il verbo amare",
    loveGod: "Ama Dio con tutto il tuo cuore",
    loveNeighbor: "Ama il prossimo come te stesso",
    lovePriority: "L'amore diventa una priorità"
  },

  unity: unityTranslations,

  footer: {
    version: "Versione 1.0 • 2024",
    dedication: "Sviluppato per la gloria di Dio"
  },

  endCredits: {
    lines: [
      { text: "Sei arrivato in cima alla montagna", delay: 2000 },
      { text: "Hai imparato molte cose", delay: 2000 },
      { text: "La tua fede cresce ogni giorno", delay: 2000 },
      { text: "Vivi cose belle con Dio", delay: 2000 },
      { text: "Le difficoltà ti aiutano a crescere", delay: 2000 },
      { text: "Esse mostrano ciò che è importante", delay: 2000 },
      { text: "Sii umile come un bambino", delay: 2000 },
      { text: "Dio ama il tuo cuore semplice", delay: 2000 },
      { text: "Nella calma ascolti Dio", delay: 2000 },
      { text: "Il digiuno libera il tuo spirito", delay: 2000 },
      { text: "Prega e Dio ti guiderà", delay: 2000 },
      { text: "L'orgoglio nasconde la verità", delay: 2000 },
      { text: "La grazia di Dio è magnifica", delay: 2000 },
      { text: "Viene dal cuore di Dio", delay: 2000 },
      { text: "La vera fede ti rende libero", delay: 2000 },
      { text: "Ti unisce a Dio per sempre", delay: 2000 },
      { text: "L'amore può cambiare tutto", delay: 2000 },
      { text: "Può fare miracoli", delay: 2000 },
      { text: "Ripeti con me", delay: 2000 },
      { text: "Gesù, ti do il mio cuore", delay: 3000 },
      { text: "Tu sei il mio re, il mio salvatore", delay: 3000 },
      { text: "Vieni a trasformare la mia vita", delay: 3000 },
      { text: "Il cammino continua ora", delay: 2000 },
      { text: "Condividi questa bella luce", delay: 2000 },
      { text: "Verso la vita che non finisce mai", delay: 2000 },
      { text: "Custodisci l'amore nel tuo cuore", delay: 3000 },
      { text: "Come un tesoro prezioso", delay: 3000 }
    ],
    finalMessages: {
      congratulations: "BRAVO!",
      proud: "SIAMO ORGOGLIOSI DI TE",
      courage: "CORAGGIO VALOROSO",
      peace: "PORTATORE DI PACE",
      child: "FIGLIO DI DIO",
      blessing: "CHE DIO TI BENEDICA",
      continue: "Continua"
    }
  },

  validation: {
    pseudoTooShort: "Il nickname deve contenere almeno 2 caratteri",
    enterPseudo: "Inserisci un nickname"
  },

  pseudoSetup: {
    title: "Scegli il tuo nickname di giocatore",
    profileConfig: "Configurazione del Profilo",
    connectedWith: "Connesso con",
    playerPseudo: "Nickname di Giocatore",
    pseudoPlaceholder: "Il tuo nickname...",
    pseudoRequirements: "2-20 caratteri • Visualizzato nelle classifiche",
    suggestions: "Suggerimenti",
    confirm: "Conferma Nickname",
    errorConfig: "Errore durante la configurazione"
  },

  navigation: {
    back: "Indietro"
  },

  console: {
    starsUnlocked: "stelle raggiunte! Sblocco capitolo",
    defeatAnimation: "Sconfitta... G.C. ridiscende"
  },

  errors: {
    progressionError: "Errore di progressione",
    invalidProgressionData: "Dati di progressione non validi:"
  },

  levels: {
    chaptersAndBonus: "8 capitoli + livello bonus",
    bonusUnlocked: "🎁 LIVELLO BONUS SBLOCCATO! Hai raggiunto la perfezione spirituale!",
    starsToDiscover: "273 {stars} da scoprire",
    starsPerLevel: "3 {stars} per livello"
  },

  architecture: {
    title: "⚙️ Architettura tecnica",
    react: {
      name: "React",
      description: "Interfaccia moderna"
    },
    modules: {
      name: "Moduli",
      description: "Caricamento dinamico"
    },
    localStorage: {
      name: "LocalStorage",
      description: "Salvataggio locale"
    },
    tailwind: {
      name: "Tailwind",
      description: "Design responsivo"
    }
  },

  gameManager: {
    title: "Salvataggio di gioco",
    saveLocal: "Salvataggio locale",
    saveCloud: "Cloud sincronizzato",
    saveWaiting: "In attesa di connessione",
    lastSave: "Ultimo salvataggio:",
    never: "Mai",
    saving: "Salvataggio...",
    save: "Salva",
    loadProgress: "Carica",
    loading: "Caricamento...",
    autoSaveEnabled: "💾 Salvataggio automatico attivato",
    saveError: "❌ Errore di salvataggio",
    gameSaved: "✅ Gioco salvato!",
    gameLoaded: "✅ Gioco caricato!"
  }
};

export default uiTranslations;
